<template>
  <div>
    <div>
      <span class="xbed-sub-title">{{title}}</span>
    </div>

    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem href="/">首页</BreadcrumbItem>
        <BreadcrumbItem href="/">个人资料</BreadcrumbItem>
        <BreadcrumbItem>修改密码</BreadcrumbItem>
      </Breadcrumb>
    </div>

    <Row class="form-content">
      <Col span="20">
      <Form ref="updatePasswordFormData" :model="updatePasswordFormData" :rules="ruleInline" :label-width="120">
        <FormItem prop="originPwd" label="请输入原密码">
          <Input type="password" v-model="updatePasswordFormData.originPwd">
          </Input>
        </FormItem>

        <FormItem prop="newPwd" label="请输入新密码">
          <Input type="password" v-model="updatePasswordFormData.newPwd">
          </Input>
        </FormItem>

        <FormItem prop="confirmNewPwd" label="再次输入新密码">
          <Input type="password" v-model="updatePasswordFormData.confirmNewPwd">
          </Input>
        </FormItem>

        <FormItem>
          <Button type="primary" @click="handleSubmit('updatePasswordFormData')">修改密码</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>

  </div>
</template>

<script>
import API from '../api'
import Utils from '../utils'

export default {
  data () {
    /**
     * 默认通用的密码校验规则
     */
    const newPwdRule = {
      required: true,
      message: '新密码必须在8～20位，必须包含数字+字母+特殊字符(例如：`~!@#$^*()-./?,<>;:\'{}|)，且不能含有%&_+=[]"、Xbed、2015、2016、2017等关键字',
      trigger: 'blur',
      pattern: '^(?![a-zA-z]+$)(?!\\d+$)(?![`~!@#$^*()-./?,<>;:\'{}|]+$)(?![a-zA-z\\d]+$)(?![a-zA-z`~!@#$^*()-./?,<>;:\'{}|]+$)(?![\\d`~!@#$^*()-./?,<>;:\'{}|]+$)[a-zA-Z\\d`~!@#$^*()-./?,<>;:\'{}|]+$',
      min: 8,
      max: 20
    }

    return {
      title: '修改密码',
      updatePasswordFormData: {
        originPwd: '',
        newPwd: '',
        confirmNewPwd: ''
      },
      ruleInline: {
        originPwd: [{
          required: true,
          message: '原密码必须在6～20位',
          trigger: 'blur',
          min: 6,
          max: 20
        }],
        newPwd: [newPwdRule],
        confirmNewPwd: [newPwdRule]
      }
    }
  },
  methods: {
    handleSubmit (name) {
      this.$Notice.config({
        top: 100
      })

      this.$refs[name].validate(async (valid) => {
        if (valid) {
          // this.$
          let token = Utils.findFromLocalStorage('vue-token')
          let username = Utils.findFromLocalStorage('vue-username')
          let env = Utils.findFromLocalStorage('env', 'dev')
          let orgPwd = this.$data.updatePasswordFormData.originPwd
          let newPwd = this.$data.updatePasswordFormData.newPwd
          let confirmNewPwd = this.$data.updatePasswordFormData.confirmNewPwd

          if (orgPwd === newPwd) {
            // 不允许新旧密码相同
            this.$Notice.error({
              title: '修改密码失败',
              desc: '新旧密码不允许相同'
            })
            this.cleanInput()
          } else if (newPwd !== confirmNewPwd) {
            // 不允许新旧密码相同
            this.$Notice.error({
              title: '修改密码失败',
              desc: '两次新密码不一致'
            })
            this.cleanInput()
          } else {
            let resp = await API.omsAPI[env].user.updatePassword(token, newPwd, orgPwd, username)

            if (resp.data.retCode) {
              this.$Notice.error({
                title: '修改密码失败',
                desc: resp.data.msg
              })
            } else {
              this.$Notice.info({
                title: '修改密码成功'
              })

              this.$data.updatePasswordFormData.originPwd = ''
              this.$data.updatePasswordFormData.newPwd = ''
              this.$data.updatePasswordFormData.confirmNewPwd = ''

              // 删除local storage 的user item
              Utils.removeItemFromLocalStorage('user')

              this.exitApp()
            }
          }
        }
      })
    },
    exitApp () {
      // TODO 以后需要改成vue 项目的登录页面
      window.location.href = 'index.php'
    },
    cleanInput () {
      this.$data.updatePasswordFormData.originPwd = ''
      this.$data.updatePasswordFormData.newPwd = ''
      this.$data.updatePasswordFormData.confirmNewPwd = ''
    }
  }
}
</script>

<style lang="scss" scoped>


.form-content {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/update-password.vue